import { apiRequest } from "@/serves/http";
import { IS_CHINA } from "@/config";
import { mapState, mapActions } from "vuex";
import { mapMutations } from 'vuex';
import analytics from "@/utils/AnalyticsCenter";
export default {
  computed: {
    ...mapState({
      levelTypeList: (state) => state.level.levelList,
      levelId: (state) => state.level.levelId,
      currency: (state) => state.user.currency,
      levelName: (state) => state.level.level_name,
      givenName: (state) => state.user.given_name,
      familyName: (state) => state.user.family_name,
      gender: (state) => state.user.gender,
      countryName: (state) => state.user.country_name,
    }),
    isLogin() {
      return this.$store.state.user.login;
    },
  },
  data() {
    return {
      currentCurrency: null, //货币
      currentCurrencyShorthand: null, // 货币简写
      currencyList: [],
    }
  },
  mounted() {
    setTimeout(()=>{
      this.selectCurrencyType();
    },1000)
  },
  methods: {
    ...mapMutations({
      SET_CURRENCYLIST: "user/SET_CURRENCYLIST",
    }),
    ...mapActions({
      refreshUser: "user/refreshUser",
    }),
    setPersonalInfo(common) {
      const before_currency = this.currentCurrency.substring(0, this.currentCurrency.indexOf(" "))
      this.currentCurrency = common;
      this.currentCurrencyShorthand = common.substring(0, common.indexOf(" "));
      let code 
      for (let i = 0; i <  this.currencyList.length; i++) {
        if ( this.currencyList[i].description === common) {
          code =  this.currencyList[i].code;
          break;
        }
      }
      const params = {
        given_name: this.givenName,
        family_name: this.familyName,
        gender: this.gender,
        country_name: this.countryName,
        currency: IS_CHINA ? "CNY" : code,
      };
      apiRequest
        .post(ApiPath.change_userInfo, params)
        .then((res) => {
          console.log(res);
          !IS_CHINA &&
            this.$message({
              message: this.$t("change_info_success"),
              type: "success",
            });
          const params = {
            before_currency: before_currency,
            after_currency: code
          }
          analytics.logEvent("hskweb_currencyswitch_click", params);
          this.refreshUser().then(res=>{
            window.location.reload();
          });
        })
        .catch(() => {
          !IS_CHINA && this.$message.error(this.$t("change_info_fail"));
        });
    },
    selectCurrencyType() {
      // 获取货币种类列表
      apiRequest.get(ApiPath.getCurrencyList).then((res) => {
        this.currencyList = res?.data?.map((item) => {
          return {
            ...item,
            description:
              JSON.parse(item.description)?.[localStorage.getItem("language")] ?? JSON.parse(item.description)?.["zh"],
          };
        });
        this.SET_CURRENCYLIST(this.currencyList)
        
        // console.log("========== this.currencyList", this.currencyList);
        // this.currentCurrency = this.currency;
        for (let i = 0; i <  this.currencyList.length; i++) {
          if ( this.currencyList[i].code === this.currency) {
            console.log(this.currencyList)
            this.currentCurrency =  this.currencyList[i].description;
            this.currentCurrencyShorthand =  this.currencyList[i].code;
            break;
          }
        }
      });
    },
  }
}